const HB_BUTTON_VISUAL_TYPES = {
  ROUNDED: 'ROUNDED',
  LINK: 'LINK',
};

const HB_BUTTON_VISUAL_TYPE_CONFIGS = {
  [HB_BUTTON_VISUAL_TYPES.ROUNDED]: {
    className: 'roundedRoot',
  },
  [HB_BUTTON_VISUAL_TYPES.LINK]: {
    className: 'linkRoot',
  },
};

export {
  HB_BUTTON_VISUAL_TYPE_CONFIGS,
  HB_BUTTON_VISUAL_TYPES,
};
